// Brand content for Roi des Rois.
// Product PRICES, IMAGES, AVAILABILITY, DESCRIPTIONS & CHECKOUT come LIVE from
// Shopify (via backend /api/shop/products). The "enrichment" below adds curated
// details (fragrance notes, family, rating) that Shopify's public feed doesn't
// expose, merged by product handle.

export const BRAND = {
  name: "ROI DES ROIS",
  tagline: "More than a fragrance. A higher standard.",
  subtitle: "Extrait de Parfum · Royalty by Roi des Rois | 2025",
};

export const SHOPIFY = {
  domain: "https://www.roidesrois.de",
  collection: "https://www.roidesrois.de/collections/all",
  cart: "https://www.roidesrois.de/cart",
};

// Curated enrichment keyed by the real Shopify product handle.
export const productEnrichment = {
  "1-rdr-limited-edition-750-only-by-roi-des-rois": {
    shortName: "1.RDR",
    order: 1,
    subtitle: "Limited Edition · 1 of 750",
    family: "Amber · Woody · Spicy",
    category: "Unisex",
    concentration: "Extrait de Parfum · 35% Öl",
    size: "50 ml",
    badge: "Limited",
    rating: 5.0,
    reviews: 312,
    ingredientsImage: "/brand/ingredients-rdr.png",
    description:
      "Macht braucht keine lauten Worte. RDR ist die Essenz von Roi des Rois in reinster Form — kompromisslos, charakterstark, unverwechselbar. Rohstoffe auf Couturier-Niveau, nur 750 Flakons.",
    top: ["Bergamotte", "Bitterorange", "Kardamom", "Ingwer", "Grapefruit"],
    heart: ["Myrrhe", "Osmanthus", "Tabak", "Safran", "Sandelholz"],
    base: ["Zedernholz", "Moschus", "Tonkabohne", "Patchouli", "Vanille"],
  },
  "1-roi-vue-limited-edition-750-only-by-roi-des-rois": {
    shortName: "2.ROI VUE",
    order: 2,
    subtitle: "Limited Edition · 1 of 750",
    family: "Fresh · Floral · Woody",
    category: "Unisex",
    concentration: "Extrait de Parfum · 35% Öl",
    size: "50 ml",
    badge: "Limited",
    rating: 5.0,
    reviews: 268,
    ingredientsImage: "/brand/ingredients-roivue.png",
    description:
      "ROI VUE ist eine Vision. Frisch und kraftvoll in der Kopfnote, warm und dunkel im Herz, holzig-weich im Abgang — ein Sillage, der Räume füllt. Nur 750 Flakons weltweit.",
    top: ["Mandarine", "Magnolie", "Beeren"],
    heart: ["Orchidee", "Jasmin", "Pflaume", "Maiglöckchen"],
    base: ["Amber", "Vanille", "Sandelholz", "Weißer Moschus"],
  },
};

// Real brand ambassadors from the campaign material (local brand assets).
export const ambassadors = [
  {
    id: "a1",
    name: "Mergim Mavraj",
    role: "Markenbotschafter · 1.RDR",
    quote: "Mein absoluter No.1 Duft, dann kommt lange nichts mehr…",
    image: "/brand/rdr-2.png",
    handle: "1-rdr-limited-edition-750-only-by-roi-des-rois",
  },
  {
    id: "a2",
    name: "Ardijan Bujupi",
    role: "Markenbotschafter · 2.ROI VUE",
    quote:
      "Mein neuer Lieblingsduft von ROI DES ROIS – ROI VUE, mein alter war Fleur de Désert von LV.",
    image: "/brand/roivue-2.png",
    handle: "1-roi-vue-limited-edition-750-only-by-roi-des-rois",
  },
];

export const testimonials = [
  {
    id: "t1",
    name: "Mergim Mavraj",
    role: "Markenbotschafter · 1.RDR",
    rating: 5,
    text: "Mein absoluter No.1 Duft, dann kommt lange nichts mehr…",
  },
  {
    id: "t2",
    name: "Ardijan Bujupi",
    role: "Markenbotschafter · 2.ROI VUE",
    rating: 5,
    text: "Mein neuer Lieblingsduft von ROI DES ROIS – ROI VUE, mein alter war Fleur de Désert von LV.",
  },
  {
    id: "t3",
    name: "Verifizierter Kunde",
    role: "Bestellung · 1.RDR",
    rating: 5,
    text: "Unglaubliche Sillage und Haltbarkeit. Die Verpackung fühlt sich an wie ein echtes Luxusprodukt — jeden Cent wert.",
  },
];

export const values = [
  {
    title: "Extrait de Parfum · 35% Öl",
    text: "Rohstoffe, die Couturierhäuser verwenden. Entwickelt für eine Duft-DNA, die nur dir gehört.",
  },
  {
    title: "Hergestellt in Frankreich",
    text: "Komponiert in der Heimat der Parfümerie — nummeriert in Deutschland.",
  },
  {
    title: "Deine Nummer wartet",
    text: "Jeder Flakon ist nummeriert. Dein Duft. Deine Identität.",
  },
  {
    title: "Limited Masterpiece Edition",
    text: "Royalty by Roi des Rois | 2025. 750 Flakons. Keine zweite Auflage.",
  },
];

export const journal = [
  {
    id: "j1",
    title: "Die Duftpyramide von 1.RDR",
    excerpt: "Von Bergamotte bis Vanille — die Kunst hinter unserer ersten Edition.",
    date: "12. Juni 2025",
    category: "Story",
    image: "/brand/ingredients-rdr.png",
  },
  {
    id: "j2",
    title: "2.ROI VUE — ein frischer Blick",
    excerpt: "Mandarine, Magnolie und Orchidee: die florale Seite der Krone.",
    date: "3. Mai 2025",
    category: "Story",
    image: "/brand/ingredients-roivue.png",
  },
  {
    id: "j3",
    title: "750 Stück. Danach nie wieder.",
    excerpt: "Warum limitierte Auflagen mehr sind als ein Duft — sie sind Identität.",
    date: "21. April 2025",
    category: "Edition",
    image: "/brand/rdr-3.jpg",
  },
];

// Real Shopify handles for direct linking.
export const HANDLES = {
  rdr: "1-rdr-limited-edition-750-only-by-roi-des-rois",
  roivue: "1-roi-vue-limited-edition-750-only-by-roi-des-rois",
};

export const heroImage = "/brand/hero-logo3.png";
export const dualImage = "/brand/life-3.png";
export const logoImage = "/brand/logo.jpeg";
